import {
  FONT_FAMILY_MAP,
  FONT_LINE_HEIGHT_MAP,
  FONT_SIZE_MAP,
} from 'consts/common'
import {FontSizeType, FontWeightType} from 'types/commons'

export function getFontSize(size: FontSizeType) {
  return FONT_SIZE_MAP[size]
}

export function getFontLineHeight(size: FontSizeType) {
  return `${FONT_LINE_HEIGHT_MAP[size]}px`
}

export function getFontFamily(type: FontWeightType) {
  return FONT_FAMILY_MAP[type]
}
